module.exports = require('./helpers/bundle-url').getBundleURL('gtHkp') + "logo.c51670a8.svg";